module.exports = __webpack_public_path__ + "static/miami-cb1675e09757228b5ffddf6d46c5efb0.png";